// Temas sazonais: logo, favicon e cores mudam automaticamente conforme o mês.
// As cores de cada tema ficam em src/styles/styles.scss (:root[data-theme="..."]).
// Para testar fora da época, use ?theme=halloween ou ?theme=christmas na URL.

const SEASONS = {
  halloween: {
    months: [9], // outubro (getMonth() começa em 0)
    logo: "/logo_halloween.webp",
    favicon: "/favicon_hallowen.ico",
    themeColor: "#ff7300",
  },
  christmas: {
    months: [11], // dezembro
    logo: "/logo_natal.webp",
    favicon: "/favicon_natal.ico",
    themeColor: "#e10000",
  },
};

function getSeasonName(date = new Date()) {
  const override = new URLSearchParams(window.location.search).get("theme");
  if (override && SEASONS[override]) return override;

  return Object.keys(SEASONS).find((name) =>
    SEASONS[name].months.includes(date.getMonth())
  );
}

export function getSeason() {
  const name = getSeasonName();
  return name ? { name, ...SEASONS[name] } : null;
}

export function getSeasonLogo(defaultLogo) {
  const season = getSeason();
  return season ? process.env.PUBLIC_URL + season.logo : defaultLogo;
}

export function applySeason() {
  const season = getSeason();
  if (!season) return;

  document.documentElement.dataset.theme = season.name;

  const favicon = document.querySelector("link[rel='icon']");
  if (favicon) favicon.href = process.env.PUBLIC_URL + season.favicon;

  const themeColor = document.querySelector("meta[name='theme-color']");
  if (themeColor) themeColor.content = season.themeColor;
}
